"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEndpoints = void 0;
const networks_1 = __importDefault(require("./networks"));
/**
 * Returns the endpoints of a specified type from a specified network.
 *
 * @param {ApiType} type - The type of API endpoints to be retrieved.
 * @param {string} network - The name of the network from which to retrieve the endpoints.
 *
 * @returns {Api[]} - An array of API endpoint objects of the specified type. If the network
 * does not exist, throws an error. If no matching endpoints are found, returns an empty array.
 */
const getEndpoints = (type, network) => {
    if (!networks_1.default[network]) {
        throw new Error(`Network ${network} does not exist.`);
    }
    return networks_1.default[network].api.filter((api) => api.type === type);
};
exports.getEndpoints = getEndpoints;
